/**
 * 检测一个对象是否为空
 * 为空返回 true
 * 非空返回 false
 * @param obj
 * @returns {boolean}
 */
export default function (obj) {
  for (let key in obj) {
    return false
  }
  return true
}
